import type { CountryId } from "./types";
import { DATA_COUNTRIES } from "./version";

export const COUNTRY_INFO: Record<CountryId, { name: string; short: string; blurb: string }> = {
  uk: { name: "United Kingdom", short: "UK", blurb: "Official counts from England and Wales, Scotland and Northern Ireland" },
  us: { name: "United States", short: "US", blurb: "Social Security records, back to 1880" },
  other: { name: "Somewhere else", short: "UK + US", blurb: "Your country's records aren't in Nameling yet, so it uses the UK's and US's together" },
};

/** The countries this build has names for, in the order they're offered. */
export const COUNTRIES: CountryId[] = (["uk", "us", "other"] as CountryId[]).filter((c) =>
  (DATA_COUNTRIES as readonly string[]).includes(c),
);

export function isAvailable(c: unknown): c is CountryId {
  return typeof c === "string" && (COUNTRIES as string[]).includes(c);
}
